import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";
import { BASE_URL } from './BaseUrl';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import InnerHeader from "./InnerHeader";
import { pdf } from "@react-pdf/renderer";
import PaymentCollectionDoc from "./Document/PayementCollectionDoc";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));


const PaymentCollectionReport = () => {
    const [vendordata, setStudent] = useState([])
    const [selectedYear, setselectedYear] = useState('');
    const [course, setCourse] = useState([])
    const [errors, setErrors] = useState({});


    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = 2000; year <= currentYear; year++) {
        years.push(year);
    }

    const [value, setValue] = useState({
        Course_Id: "",
        criteria: "",
        years: "",
        year: "",
    })

    const getCourseData = () => {

        const data = {
            tablename: "Course_Mst",
            columnname: "Course_Id,Course_Name"
        }

        axios.post(`${BASE_URL}/get_new_data`, data)
            .then((res) => {
                console.log(res.data)
                setCourse(res.data)
            })
            .catch((err) => {
                console.log(err)
            })

    }

    const handleSubmit = (e) => {
        e.preventDefault();

        let newErrors = {};

        if (!value.criteria) newErrors.criteria = "Criteria is required";
        if (!value.Course_Id) newErrors.Course_Id = "Course is required";
        if (!value.years) newErrors.years = "From Year is required";

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            return; // Stop execution if errors found
        }

        getDetails(); // No errors, proceed
    }


    useEffect(() => {
        getCourseData()
    }, [])

    const onhandleChange = (e) => {
        const { name, value: selectedValue } = e.target;

        if (name === 'Course_Id' && selectedValue === 'all') {
            // If 'Select All' is chosen, collect all Course IDs as CSV string
            const allCourseIds = course.map(item => item.Course_Id).join(',');
            setValue((prev) => ({
                ...prev,
                [name]: allCourseIds
            }));
        } else {
            setValue((prev) => ({
                ...prev,
                [name]: selectedValue,
                year: name === 'years' ? parseInt(selectedValue) + 1 : prev.year
            }));
        }
    };


    const [pdfdata, setpdfData] = useState([]);

    async function getDetails() {
        const param = {
            Course_Id: value.Course_Id,
            years: value.years,
            year: value.year,
        };

        axios.post(`${BASE_URL}/getpaymentcollectionreport`, param).then((res) => {
            setpdfData(res.data);
            collectionreport(res.data)
        });
    }

    // useEffect(() => {
    //     getDetails();
    // }, []);

    const collectionreport = async (data) => {
        const blob = await pdf(<PaymentCollectionDoc data={data} />).toBlob();
        const url = URL.createObjectURL(blob);
        window.open(url);
        URL.revokeObjectURL(url);
    };


    return (

        <div class="container-fluid page-body-warpper ">
            <InnerHeader />
            <div class="main-panel">
                <div class="content-wrapper">
                    <div class="row">
                        <div class="col-lg-12 grid-margin stretch-card">
                            <div class="card">
                                <div class="card-body">
                                    <h4 class="card-title">
                                        Payment Collection New
                                    </h4>
                                    <hr></hr>

                                    <form class="form-sample py-3" onSubmit={handleSubmit} >
                                        <div class="row">

                                            <div class="form-group col-lg-3">
                                                <lable for="exampleFormControlSelect1">Select Criteria</lable>
                                                <select class="form-control" id="exampleFormControlSelect1"
                                                    value={value.criteria} name="criteria"
                                                    onChange={onhandleChange}>
                                                    <option value="">--Select Criteria--</option>
                                                    <option value="coursewise">CourseWise</option>
                                                    <option value="batchwise">BatchWise</option>
                                                </select>
                                                {errors.criteria && <div className="text-danger">{errors.criteria}</div>}
                                            </div>

                                            <div class="form-group col-lg-3">
                                                <lable for="exampleFormControlSelect1">Select Course</lable>
                                                <select class="form-control" id="exampleFormControlSelect1"
                                                    value={value.Course_Id} name='Course_Id' onChange={onhandleChange}>
                                                    <option value="all"> All</option>
                                                    {(Array.isArray(course) ? course : []).filter((c) => c && c.IsDelete != 1 && c.isDelete != 1 && c.deleted != 1).map((item) => {
                                                        return (
                                                            <option value={item.Course_Id}>{item.Course_Name}</option>

                                                        )
                                                    })}
                                                </select>
                                                {errors.Course_Id && <div className="text-danger">{errors.Course_Id}</div>}
                                            </div>

                                            <div className="form-group col-lg-3">
                                                <label htmlFor="yearInput">Year</label>
                                                <select
                                                    className="form-control"
                                                    id="yearInput"
                                                    value={value.years}
                                                    name="years"
                                                    onChange={onhandleChange}
                                                >
                                                    <option value="">--Select Year--</option>
                                                    <option value="2001">2001</option>
                                                    <option value="2002">2002</option>
                                                    <option value="2003">2003</option>
                                                    <option value="2004">2004</option>
                                                    <option value="2005">2005</option>
                                                    <option value="2006">2006</option>
                                                    <option value="2007">2007</option>
                                                    <option value="2008">2008</option>
                                                    <option value="2009">2009</option>
                                                    <option value="2010">2010</option>
                                                    <option value="2011">2011</option>
                                                    <option value="2012">2012</option>
                                                    <option value="2013">2013</option>
                                                    <option value="2014">2014</option>
                                                    <option value="2015">2015</option>
                                                    <option value="2016">2016</option>
                                                    <option value="2017">2017</option>
                                                    <option value="2018">2018</option>
                                                    <option value="2019">2019</option>
                                                    <option value="2020">2020</option>
                                                    <option value="2021">2021</option>
                                                    <option value="2022">2022</option>
                                                    <option value="2023">2023</option>
                                                    <option value="2024">2024</option>
                                                    <option value="2025">2025</option>
                                                </select>
                                                {errors.years && <div className="text-danger">{errors.years}</div>}
                                            </div>

                                            <div class="fomr-group col-lg-3 py-4">
                                                <lable for="exampleInputUsername1"></lable>
                                                <input type="year" class="form-control" id="exampleInputUsername1"
                                                    value={value.year}
                                                    name="year" onChange={onhandleChange} disabled />

                                            </div>

                                        </div>

                                        <button type="submit" class="btn btn-primary mr-2" >Print</button>
                                        <button type='button' onClick={() => {
                                            window.location.reload()
                                        }} class="btn btn-light">Back</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default PaymentCollectionReport